// TODO: Update types to be more detaild in the future
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
import { NULL } from "constants/primitives";
import isObject from "./isObject";

type GetByPath = <T extends any = any, F extends any = T>(
  object: Record<string, any>,
  path: string,
  fallback?: F | null
) => T | F;
const getByPath: GetByPath = <T, F>(
  object: Record<string, any>,
  path: string,
  fallback: F | null = NULL
): T | F => {
  let currentObject = object;
  const pathParts = path.split(".");
  for (let i = 0; i < pathParts.length; i++) {
    const key = pathParts[i];
    const nextObject = currentObject[key];

    // last key
    if (i === pathParts.length - 1) {
      return typeof nextObject === "undefined" ? fallback : nextObject;
    }

    if (!nextObject || !isObject(nextObject)) {
      return fallback as F;
    }

    currentObject = nextObject;
  }

  return fallback as F;
};

export default getByPath;
